import { buildSummaryRows, formatPct } from './marketDataUtils';

function SummaryCardSkeleton() {
  return (
    <div className="col-6 col-md-4 col-xl-2">
      <div className="card border-light shadow-sm card-metric h-100">
        <div className="card-body py-3">
          <div className="market-summary-skeleton-label" />
          <div className="market-summary-skeleton-value" />
        </div>
      </div>
    </div>
  );
}

function MarketIndexSummaryCards(props) {
  const { series, loading, skeletonCount = 6 } = props;

  if (loading) {
    return (
      <>
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <SummaryCardSkeleton key={index} />
        ))}
      </>
    );
  }

  const rows = buildSummaryRows(series);

  return (
    <>
      {rows.map((row) => {
        const changeClass = row.dayChange >= 0 ? 'text-success' : 'text-danger';
        return (
          <div className="col-6 col-md-4 col-xl-2" key={row.name}>
            <div className="card border-light shadow-sm card-metric h-100">
              <div className="card-body py-3">
                <div className="d-flex align-items-start mb-2">
                  <span
                    className="market-summary-swatch"
                    style={{ backgroundColor: row.color }}
                  />
                  <div style={{ minWidth: 0 }}>
                    <div className="text-muted small text-truncate">{row.name}</div>
                    <div className="text-muted small">(Today)</div>
                  </div>
                </div>
                <div className={`h4 mb-0 ${row.dayChange === null ? '' : changeClass}`}>
                  {formatPct(row.dayChange)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default MarketIndexSummaryCards;
